const ENV_OPTIONS: Record<string, string> = {
  DEVELOPMENT: 'krg.io',
  DEV: 'dev.kargo.com',
  STAGING: 'staging.kargo.com',
};

export function getKDWBaseUrl(host: string = window.location.host): string {
  let kdwUrlEnv = 'etl';

  for (const value of Object.values(ENV_OPTIONS)) {
    if (host.includes(value)) {
      kdwUrlEnv = 'staging';
      break;
    }
  }

  return `https://segment-api.${kdwUrlEnv}.kargo.com`;
}
